/* ═══════════════════════════════════════════════════════════════
   VAUPEL Theme JS — lightweight vanilla
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // ── Helpers ────────────────────────────────────────────────
  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const fmtMoney = (cents) => {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
    } catch { return (cents / 100).toFixed(2) + ' €'; }
  };

  // ── E-Mail-Links entschleiern (Anti-Harvesting) ─────────────
  // Adresse steht rückwärts im data-e; hier wieder zusammensetzen.
  $$('.js-mail').forEach(function (a) {
    var rev = a.getAttribute('data-e') || '';
    if (!rev) return;
    var mail = rev.split('').reverse().join('');
    a.setAttribute('href', 'mailto:' + mail);
    if (a.getAttribute('data-show') === '1') a.textContent = mail;
  });

  // ── Terminauswahl-Popup (data-taus) ─────────────────────────
  // Ein Button öffnet ein eigenes Popup mit mehreren Termin-Optionen;
  // jede Option ist ein cal.com-Link, den cal-booking.js abfängt.
  (function () {
    function openTaus(ov) {
      if (!ov) return;
      ov.hidden = false;
      requestAnimationFrame(function () { ov.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    }
    function closeTaus(ov) {
      if (!ov) return;
      ov.classList.remove('is-open');
      setTimeout(function () { ov.hidden = true; }, 250);
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-taus-open]');
      if (opener) {
        openTaus(document.querySelector('[data-taus="' + opener.getAttribute('data-taus-open') + '"]'));
        return;
      }
      // Beliebiger Link auf #ankername öffnet das passende Popup (statt zu scrollen)
      var anchor = e.target.closest('a[href^="#"]');
      if (anchor) {
        var id = anchor.getAttribute('href').slice(1);
        var ovA = id ? document.querySelector('[data-taus-anchor="' + id.replace(/"/g, '') + '"]') : null;
        if (ovA) { e.preventDefault(); openTaus(ovA); return; }
      }
      if (e.target.closest('[data-taus-close]')) { closeTaus(e.target.closest('[data-taus]')); return; }
      // Klick auf eine Option → cal.com öffnet sich, Auswahl-Popup schließen
      var opt = e.target.closest('.taus__opt');
      if (opt) { var ovClose = opt.closest('[data-taus]'); setTimeout(function () { closeTaus(ovClose); }, 60); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var ov = document.querySelector('[data-taus].is-open'); if (ov) closeTaus(ov); }
    });
  })();

  // ── Mobile menu ────────────────────────────────────────────
  const mobileMenu = $('[data-mobile-menu]');
  const overlay    = $('[data-overlay]');
  $$('[data-mobile-menu-toggle]').forEach(btn =>
    btn.addEventListener('click', () => openPanel(mobileMenu))
  );
  $$('[data-mobile-menu-close]').forEach(btn =>
    btn.addEventListener('click', () => closePanel(mobileMenu))
  );

  // Desktop: Menü bei Mouseover öffnen (intuitiver als Klick). Kleiner
  // Öffnungs-Verzug, damit es nicht schon beim Überfahren aufspringt; ein
  // Schließ-Verzug überbrückt den Weg vom Icon zum Panel. Schließen: Maus
  // verlässt Icon UND Panel → zu. Der X-Button und Klick funktionieren weiter.
  const hoverMQ = window.matchMedia('(hover: hover) and (min-width: 901px)');
  const deskBurger = $('.header__burger--desktop');
  if (deskBurger && mobileMenu) {
    let openT = null, closeT = null;
    const hoverOpen = () => {
      if (!hoverMQ.matches) return;
      clearTimeout(closeT);
      openT = setTimeout(() => openPanel(mobileMenu), 120);
    };
    const hoverCloseSoon = () => {
      if (!hoverMQ.matches) return;
      clearTimeout(openT);
      closeT = setTimeout(() => closePanel(mobileMenu), 300);
    };
    deskBurger.addEventListener('mouseenter', hoverOpen);
    deskBurger.addEventListener('mouseleave', hoverCloseSoon);
    mobileMenu.addEventListener('mouseenter', () => { if (hoverMQ.matches) clearTimeout(closeT); });
    mobileMenu.addEventListener('mouseleave', hoverCloseSoon);
  }

  // Aufklappbare Menü-Gruppen (z. B. Shop) — JS steuert die Höhe, damit
  // Öffnen UND Schließen animieren (natives <details> schließt hart) und
  // der erste Tipp sofort greift (preventDefault umgeht den Hover-Tap).
  $$('.mobile-menu__group').forEach(function (grp) {
    var btn = grp.querySelector('.mobile-menu__toggle');
    var inner = grp.querySelector('.mobile-menu__sublist-inner');
    if (!btn || !inner) return;
    btn.addEventListener('click', function () {
      if (grp.dataset.animating) return;
      grp.dataset.animating = '1';
      var opening = !grp.classList.contains('is-open');
      btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        grp.classList.add('is-open');            // Pfeil dreht sofort
        inner.style.height = '0px';
        void inner.offsetHeight;                 // Start-Höhe committen
        inner.style.height = inner.scrollHeight + 'px';
      } else {
        inner.style.height = inner.scrollHeight + 'px';  // aktuelle Höhe fixieren …
        void inner.offsetHeight;                 // … und committen, bevor auf 0
        grp.classList.remove('is-open');         // Pfeil dreht sofort
        inner.style.height = '0px';
      }
      setTimeout(function () {
        if (grp.classList.contains('is-open')) inner.style.height = '';
        delete grp.dataset.animating;
      }, 360);
    });
  });

  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    overlay?.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    if (!document.querySelector('.is-open')) {
      overlay?.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }
  overlay?.addEventListener('click', () => {
    $$('.is-open').forEach(el => el.classList.remove('is-open'));
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      $$('.is-open').forEach(el => el.classList.remove('is-open'));
      overlay?.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  });

  // ── Cart drawer ────────────────────────────────────────────
  const cartDrawer = $('[data-cart-drawer]');

  async function refreshCart() {
    try {
      const resp = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await resp.json();
      renderCart(cart);
    } catch (err) { console.error('[cart] refresh failed:', err); }
  }

  /* ── Warenkorb-Empfehlungen ────────────────────────────────
     Liquid liefert nur den Kandidaten-Pool; welche 3 Produkte
     erscheinen, entscheidet der Restbetrag bis zum Gratisversand:
     fehlen 35 €, wird eine 35-€-Brille vorgeschlagen — fehlen 10 €,
     eher ein Basic. Der beste Treffer steht fix vorn, die zwei
     weiteren werden aus den nächstbesten gelost, damit nicht immer
     dieselben drei erscheinen.                                      */
  const upsellEl  = $('[data-upsell]');
  const upsellRow = $('[data-upsell-row]');
  const upsellHd  = $('[data-upsell-head]');
  let upsellPool = [];
  try {
    const poolEl = $('[data-upsell-pool]');
    if (poolEl) upsellPool = JSON.parse(poolEl.textContent) || [];
  } catch (e) { upsellPool = []; }

  const escHtml = (str) => String(str).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));

  function renderUpsell(cart) {
    if (!upsellEl || !upsellRow || !upsellPool.length) return;

    // Was schon im Warenkorb liegt, nicht nochmal vorschlagen.
    // Zusätzlich pro Titel nur EIN Produkt: Serien wie „Hochzeithemd – ivory"
    // liegen als mehrere Produkte (Passformen) zum selben Preis im Shop und
    // bekommen dadurch denselben Rang — sonst stünde dort 3× dasselbe.
    const inCart = new Set((cart.items || []).map((i) => i.product_id));
    const seenTitle = new Set();
    const cands = upsellPool.filter((p) => {
      if (inCart.has(p.id)) return false;
      const key = String(p.t || '').trim().toLowerCase();
      if (seenTitle.has(key)) return false;
      seenTitle.add(key);
      return true;
    });
    if (!cands.length) { upsellEl.hidden = true; return; }

    const shipbar   = $('[data-shipbar]', cartDrawer);
    const threshold = shipbar ? (parseInt(shipbar.dataset.threshold, 10) || 0) : 0;
    const remaining = threshold - (cart.total_price || 0);

    let ranked;
    if (remaining > 0) {
      // Wer die Lücke schließt, zuerst (kleinster Überschuss);
      // knapp darunter danach — Abstand zählt doppelt.
      const score = (p) => (p.p >= remaining
        ? (p.p - remaining)
        : (remaining - p.p) * 2 + 1e6);
      ranked = cands.slice().sort((a, b) => score(a) - score(b));
    } else {
      // Gratisversand schon erreicht → günstige Ergänzungen
      ranked = cands.slice().sort((a, b) => a.p - b.p);
    }

    const pick = ranked.slice(0, 1);
    const rest = ranked.slice(1, 6);
    for (let i = rest.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [rest[i], rest[j]] = [rest[j], rest[i]];
    }
    pick.push(...rest.slice(0, 2));

    upsellRow.innerHTML = pick.map((p) => `
      <a href="${escHtml(p.u)}" class="cart-upsell__item">
        ${p.img ? `<img src="${escHtml(p.img)}" alt="" loading="lazy">` : ''}
        <span class="cart-upsell__name">${escHtml(p.t)}</span>
        <span class="cart-upsell__price">${fmtMoney(p.p)}</span>
      </a>`).join('');

    // Überschrift wird konkret, wenn der Top-Vorschlag den Gratisversand auslöst
    if (upsellHd) {
      const closesGap = remaining > 0 && pick[0] && pick[0].p >= remaining;
      upsellHd.textContent = closesGap
        ? (upsellEl.dataset.upsellHeadGap || upsellHd.textContent)
        : (upsellEl.dataset.upsellHeadDefault || upsellHd.textContent);
    }
    upsellEl.hidden = false;
  }

  function renderCart(cart) {
    if (!cartDrawer) return;
    const body = $('[data-cart-body]',  cartDrawer);
    const foot = $('[data-cart-foot]',  cartDrawer);
    const counters = $$('[data-cart-count]');

    if (counters.length) {
      counters.forEach(c => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    }

    // Gratisversand-Progressbar
    const shipbar = $('[data-shipbar]', cartDrawer);
    if (shipbar) {
      const threshold = parseInt(shipbar.dataset.threshold, 10) || 0;
      const label = $('[data-shipbar-label]', shipbar);
      const fill  = $('[data-shipbar-fill]',  shipbar);
      const reached = cart.total_price >= threshold;
      if (fill) {
        fill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
        fill.classList.toggle('is-reached', reached);
      }
      if (label) {
        label.classList.toggle('is-reached', reached);
        label.innerHTML = reached
          ? '✓ Gratisversand erreicht'
          : `Noch <strong>${fmtMoney(threshold - cart.total_price)}</strong> bis zum Gratisversand`;
      }
    }

    renderUpsell(cart);

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Dein Warenkorb ist leer.</p><a href="/collections/all" class="btn btn--ghost">Weiter stöbern</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;

    body.innerHTML = cart.items.map(item => {
      const props = (item.properties && Object.keys(item.properties).filter(k => !k.startsWith('_') && k !== 'Hinweis').map(k =>
        `<span>${k}: ${item.properties[k]}</span>`
      ).join('')) || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__info-variant">${item.variant_title}</div>` : '';
      return `
        <div class="cart-drawer__row" data-line="${item.key}">
          <img class="cart-drawer__img" src="${(item.properties && (item.properties._produktbild || item.properties._stoffbild)) || (item.image ? item.image.replace(/\.([a-z]+)$/, '_140x.$1') : '')}" alt="">
          <div>
            <a href="${item.url}" class="cart-drawer__info-title">${item.product_title}</a>
            ${variant}
            <div class="cart-drawer__info-meta">${props}</div>
            <div class="cart-drawer__qty">
              <button type="button" data-qty-change="-1" aria-label="Weniger">−</button>
              <input type="number" min="0" value="${item.quantity}" data-qty-input>
              <button type="button" data-qty-change="+1" aria-label="Mehr">+</button>
            </div>
            <a href="#" class="cart-drawer__remove" data-remove>Entfernen</a>
          </div>
          <div class="cart-drawer__price">${fmtMoney(item.final_line_price)}</div>
        </div>
      `;
    }).join('');

    const totalEl = $('[data-cart-total]', cartDrawer);
    if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);

    // Bind qty buttons
    $$('[data-line]', body).forEach(row => {
      const key = row.dataset.line;
      $$('[data-qty-change]', row).forEach(btn => {
        btn.addEventListener('click', () => {
          const input = $('[data-qty-input]', row);
          const delta = parseInt(btn.dataset.qtyChange, 10);
          const next  = Math.max(0, parseInt(input.value, 10) + delta);
          updateLine(key, next);
        });
      });
      $('[data-qty-input]', row).addEventListener('change', e => {
        updateLine(key, Math.max(0, parseInt(e.target.value, 10) || 0));
      });
      $('[data-remove]', row).addEventListener('click', e => {
        e.preventDefault();
        updateLine(key, 0);
      });
    });
  }

  async function updateLine(key, quantity) {
    try {
      const resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await resp.json();
      renderCart(cart);
    } catch (err) { console.error('[cart] update failed:', err); }
  }

  $$('[data-cart-toggle]').forEach(btn => btn.addEventListener('click', (e) => {
    if (!cartDrawer) return;          // ohne Drawer: normaler Link zu /cart
    e.preventDefault();
    refreshCart();
    openPanel(cartDrawer);
  }));
  $$('[data-cart-close]').forEach(btn => btn.addEventListener('click', () => closePanel(cartDrawer)));

  // ── Cross-component cart update event ───────────────────
  // Vom Konfigurator (und anderen Add-to-Cart-Quellen) gefeuert.
  document.addEventListener('konfigurator:cart-updated', () => {
    refreshCart();
  });

  // Initial cart count fetch
  if ($('[data-cart-count]')) {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      $$('[data-cart-count]').forEach(c => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
      renderUpsell(cart);
    }).catch(() => {});
  }

  // ── Add-to-cart form interception ─────────────────────────
  $$('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const orig = btn?.innerHTML;
      if (btn) { btn.disabled = true; btn.innerHTML = 'Wird hinzugefügt …'; }
      try {
        const fd = new FormData(form);
        const resp = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!resp.ok) throw new Error(await resp.text());
        await refreshCart();
        openPanel(cartDrawer);
      } catch (err) {
        alert('Konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
        console.error(err);
      } finally {
        if (btn) { btn.disabled = false; btn.innerHTML = orig; }
      }
    });
  });

  // ── Product gallery thumbs + Zoom ─────────────────────────
  const galMain = $('[data-gallery-main]');
  if (galMain) {
    $$('[data-gallery-thumb]').forEach(btn => {
      btn.addEventListener('click', () => {
        $$('[data-gallery-thumb]').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const img = galMain.querySelector('img');
        if (img) {
          img.removeAttribute('srcset');   // sonst gewinnt das alte srcset gegen das neue src
          img.src = btn.dataset.fullSrc || btn.querySelector('img').src;
        }
      });
    });

    // Klick aufs große Bild → Zoom-Lightbox (dunkler Blur-Backdrop)
    const zoom = document.createElement('div');
    zoom.className = 'gallery-zoom';
    zoom.innerHTML = '<img alt="">';
    document.body.appendChild(zoom);
    const zoomImg = zoom.querySelector('img');

    galMain.addEventListener('click', () => {
      const img = galMain.querySelector('img');
      if (!img || !img.currentSrc && !img.src) return;
      zoomImg.src = img.currentSrc || img.src;
      zoom.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    const closeZoom = () => {
      zoom.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    zoom.addEventListener('click', closeZoom);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && zoom.classList.contains('is-open')) closeZoom();
    });
  }

  // ── Variant pills (product page) ─────────────────────────
  const variantForm = $('[data-variant-form]');
  if (variantForm) {
    const variants = JSON.parse(variantForm.dataset.variants || '[]');
    const selects  = $$('[data-option-select]', variantForm);

    function applyVariant() {
      const opts = selects.map(s => s.value);
      const found = variants.find(v => v.options.every((o, i) => o === opts[i]));
      const idInput = $('[name="id"]', variantForm);
      const submit  = $('[type="submit"]', variantForm);
      const priceEl = $('[data-price]');
      if (!found) {
        if (submit) { submit.disabled = true; submit.innerHTML = 'Nicht verfügbar'; }
        return;
      }
      if (idInput) idInput.value = found.id;
      if (submit) {
        submit.disabled = !found.available;
        submit.innerHTML = found.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      if (priceEl && found.price != null) priceEl.textContent = fmtMoney(found.price);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', found.id);
      history.replaceState({}, '', url);
    }

    $$('[data-option-pills]', variantForm).forEach(group => {
      const idx = parseInt(group.dataset.optionPills, 10);
      $$('button', group).forEach(b => b.addEventListener('click', () => {
        if (b.classList.contains('is-soldout')) return;
        $$('button', group).forEach(x => x.classList.remove('is-active'));
        b.classList.add('is-active');
        selects[idx].value = b.dataset.value;
        applyVariant();
      }));
    });

    selects.forEach(s => s.addEventListener('change', applyVariant));
  }

  // Qty steppers on product/cart page
  $$('[data-qty-stepper]').forEach(stepper => {
    const input = stepper.querySelector('input');
    stepper.querySelector('[data-qty-dec]')?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    stepper.querySelector('[data-qty-inc]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // ── Cookie banner ─────────────────────────────────────────
  const cookieBanner = $('[data-cookie-banner]');
  if (cookieBanner) {
    if (!localStorage.getItem('vp_cookie_ok')) {
      setTimeout(() => cookieBanner.classList.add('is-visible'), 600);
    }
    $('[data-cookie-accept]', cookieBanner)?.addEventListener('click', () => {
      localStorage.setItem('vp_cookie_ok', '1');
      cookieBanner.classList.remove('is-visible');
    });
  }

  // ── Such-Overlay mit Predictive Search ───────────────────
  // Nutzt Shopifys natives /search/suggest.json — keine App nötig.
  const searchOverlay = $('[data-search-overlay]');
  if (searchOverlay) {
    const input    = $('[data-search-input]',   searchOverlay);
    const results  = $('[data-search-results]', searchOverlay);
    const hint     = $('[data-search-hint]',    searchOverlay);
    let lastFocus  = null;
    let debounceT  = null;
    let reqSeq     = 0;

    function openSearch() {
      lastFocus = document.activeElement;
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => input?.focus(), 50);
    }
    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lastFocus?.focus?.();
    }

    $$('[data-search-toggle]').forEach(btn => btn.addEventListener('click', () => {
      const menu = $('[data-mobile-menu]');
      if (menu?.classList.contains('is-open')) {
        menu.classList.remove('is-open');
        $('[data-overlay]')?.classList.remove('is-active');
      }
      openSearch();
    }));
    $$('[data-search-close]', searchOverlay).forEach(el => el.addEventListener('click', closeSearch));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) closeSearch();
    });

    async function fetchSuggestions(q) {
      const seq = ++reqSeq;
      const url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=6'
        + '&resources[options][unavailable_products]=last';
      try {
        const resp = await fetch(url, { headers: { Accept: 'application/json' } });
        const data = await resp.json();
        if (seq !== reqSeq) return;   // veraltete Antwort verwerfen
        renderSuggestions(q, data?.resources?.results?.products || []);
      } catch (_) { /* Netzwerkfehler → still bleiben */ }
    }

    function renderSuggestions(q, products) {
      if (!results) return;
      if (!products.length) {
        results.innerHTML = `<p class="search-overlay__empty">Keine Treffer für „${q.replace(/</g,'&lt;')}“.</p>`;
        results.hidden = false;
        return;
      }
      results.innerHTML = products.map(p => `
        <a class="search-result" href="${p.url}">
          <span class="search-result__media">
            ${p.featured_image?.url ? `<img src="${p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2')}" alt="" loading="lazy">` : ''}
          </span>
          <span class="search-result__info">
            <span class="search-result__title">${p.title}</span>
            <span class="search-result__price">${p.price ? fmtMoney(Math.round(parseFloat(p.price) * 100)) : ''}</span>
          </span>
          <span class="search-result__arrow" aria-hidden="true">→</span>
        </a>
      `).join('') + `
        <a class="search-overlay__all" href="/search?q=${encodeURIComponent(q)}">Alle Ergebnisse anzeigen →</a>
      `;
      results.hidden = false;
    }

    input?.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(debounceT);
      if (q.length < 2) {
        if (results) { results.hidden = true; results.innerHTML = ''; }
        return;
      }
      debounceT = setTimeout(() => fetchSuggestions(q), 220);
    });
  }

  // ── Quick-View-Modal ──────────────────────────────────────
  // Lädt /products/<handle>.js (natives Shopify-Produkt-JSON).
  const qv = $('[data-quickview]');
  if (qv) {
    const qvBody = $('[data-quickview-body]', qv);
    let qvLastFocus = null;

    function openQv()  {
      qvLastFocus = document.activeElement;
      qv.classList.add('is-open');
      qv.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeQv() {
      qv.classList.remove('is-open');
      qv.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (qvBody) qvBody.innerHTML = '';
      qvLastFocus?.focus?.();
    }
    $$('[data-quickview-close]', qv).forEach(el => el.addEventListener('click', closeQv));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && qv.classList.contains('is-open')) closeQv();
    });

    function renderQv(product) {
      const img = product.images?.[0] || '';
      const hasVariants = product.variants.length > 1;
      const available = product.variants.some(v => v.available);
      qvBody.innerHTML = `
        <div class="qv__media">
          ${img ? `<img src="${img}" alt="${product.title.replace(/"/g,'&quot;')}">` : ''}
        </div>
        <div class="qv__info">
          <h3 class="qv__title">${product.title}</h3>
          <p class="qv__price" data-qv-price>${fmtMoney(product.variants[0].price)}</p>
          ${hasVariants ? `
            <label class="field-label" for="qvVariant">Variante</label>
            <select class="field qv__select" id="qvVariant" data-qv-variant>
              ${product.variants.map(v => `<option value="${v.id}" data-price="${v.price}" ${v.available ? '' : 'disabled'}>${v.title}${v.available ? '' : ' — ausverkauft'}</option>`).join('')}
            </select>
          ` : `<input type="hidden" data-qv-variant value="${product.variants[0].id}">`}
          <button class="btn btn--block qv__add" data-qv-add ${available ? '' : 'disabled'}>
            ${available ? 'In den Warenkorb' : 'Ausverkauft'}
          </button>
          <a class="btn--link qv__details" href="${product.url}">Alle Details ansehen →</a>
        </div>
      `;

      const sel = $('[data-qv-variant]', qvBody);
      if (sel?.tagName === 'SELECT') {
        sel.addEventListener('change', () => {
          const opt = sel.selectedOptions[0];
          const priceEl = $('[data-qv-price]', qvBody);
          if (priceEl && opt?.dataset.price) priceEl.textContent = fmtMoney(parseInt(opt.dataset.price, 10));
        });
      }

      $('[data-qv-add]', qvBody)?.addEventListener('click', async (e) => {
        const btn = e.currentTarget;
        const variantId = sel?.value;
        if (!variantId) return;
        btn.disabled = true;
        const orig = btn.textContent;
        btn.textContent = 'Wird hinzugefügt …';
        try {
          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
          });
          if (!resp.ok) throw new Error('add failed');
          closeQv();
          await refreshCart();
          openPanel(cartDrawer);
        } catch (_) {
          btn.textContent = 'Fehler — nochmal versuchen';
          btn.disabled = false;
          return;
        }
        btn.textContent = orig;
        btn.disabled = false;
      });
    }

    document.addEventListener('click', async (e) => {
      const trigger = e.target.closest('[data-quickview-handle]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      openQv();
      qvBody.innerHTML = '<p class="qv__loading">Lädt …</p>';
      try {
        const resp = await fetch(`/products/${trigger.dataset.quickviewHandle}.js`, { headers: { Accept: 'application/json' } });
        renderQv(await resp.json());
      } catch (_) {
        qvBody.innerHTML = '<p class="qv__loading">Konnte Produkt nicht laden.</p>';
      }
    });
  }

})();

/* ═══════════════════════════════════════════════════════════════
   Motion — Scroll-Reveals, Parallax & Header-Schatten
   Konfigurierbar über Theme-Settings → „Animationen"
   (window.VAUPEL_MOTION = { enabled, parallax }).
   Shop-nahe Bereiche (Produktseite, Warenkorb, Checkout-Wege)
   bekommen bewusst KEINE Scroll-Effekte — nur Mikro-Interaktionen.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var cfg      = window.VAUPEL_MOTION || {};
  var enabled  = cfg.enabled !== false;   // Default: an (auch wenn Setting noch nie gespeichert wurde)
  var reduced  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 900px)').matches;

  // ── Smart-Sticky-Header ────────────────────────────────────
  // Runterscrollen: Header gleitet nach oben weg. Hochscrollen:
  // er kommt sofort zurück (mit Schatten). Das eigentliche Kleben
  // übernimmt der .shopify-section-Wrapper (CSS :has) — sticky auf
  // dem Header selbst griff nie, weil sein Wrapper nur headerhoch ist.
  var header = document.querySelector('.header--sticky');
  if (header) {
    var lastY = window.scrollY;
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      if (y > lastY && y > 160) {
        header.classList.add('is-hidden');      // abwärts → ausblenden
      } else if (y < lastY - 2 || y <= 160) {
        header.classList.remove('is-hidden');   // aufwärts → einblenden
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Ruhige Variante: Setting aus, Systemwunsch „weniger Bewegung"
  // oder alter Browser → alles sofort sichtbar, kein Parallax.
  if (!enabled || reduced || !('IntersectionObserver' in window)) return;

  /* ─────────────────────────────────────────────────────────────
     1) Scroll-Reveals
     Elemente blenden beim Hereinscrollen ein. Richtung/Charakter
     je nach Element: Medien seitlich bzw. mit leichtem Scale,
     Text von unten. Karten in Rastern gestaffelt.
     ───────────────────────────────────────────────────────────── */

  // Von unten (Standard): Überschriftenblöcke, Karten, Texte
  var TARGETS_UP = [
    '.section-head',
    '.feature-card',
    '.gen-card',
    '.material-card',
    '.timeline-item',
    '.review',
    '.product-card',
    '.faq-item',
    '.konfig-teaser__step',
    '.cfi__step',
    '.cfi__media',
    '.cfi__copy',
    '.newsletter__inner',
    '.contact-form .card',
    '.footer__grid > *'
  ].join(', ');

  // Seitlich: Bild-Text-Sektionen — Bild kommt von seiner Seite,
  // Text von der gegenüberliegenden. Wirkt wie „Zusammensetzen".
  var TARGETS_SIDE = [
    '.imgtext__media', '.imgtext__copy',
    '.story-split__media', '.story-split__copy',
    '.konfig-teaser__media', '.konfig-teaser__body'
  ].join(', ');

  // Mit leichtem Scale: große Einzelmedien und Galerie-Kacheln
  var TARGETS_SCALE = [
    '.insta-grid > *',
    '.gallery-grid > *'
  ].join(', ');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        el.classList.add('is-visible');
        io.unobserve(el);
        // Nach dem Reveal die Reveal-Klassen abräumen: deren träge
        // transform/opacity-Transition (+ Stagger-Delay) würde sonst
        // Hover-Animationen der Komponenten (z. B. Karten-Offset)
        // dauerhaft ausbremsen.
        setTimeout(function () {
          el.classList.remove('vp-reveal', 'vp-reveal--left', 'vp-reveal--right', 'vp-reveal--scale');
          el.style.removeProperty('--vp-delay');
        }, 900);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function prepare(el, variant) {
    if (el.classList.contains('vp-reveal')) return;
    // bereits im Viewport (above the fold)? → nicht verstecken
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) return;
    // Stagger: Position unter Geschwistern gleicher Klasse im selben Elternelement
    var parent = el.parentElement;
    if (parent) {
      var siblings = Array.prototype.filter.call(parent.children, function (c) {
        return c.className === el.className;
      });
      var idx = siblings.indexOf(el);
      if (idx > 0) el.style.setProperty('--vp-delay', Math.min(idx * 0.06, 0.24) + 's');
    }
    el.classList.add('vp-reveal');
    if (variant) el.classList.add(variant);
    io.observe(el);
  }

  function initReveals(root) {
    var scope = root || document;
    scope.querySelectorAll(TARGETS_UP).forEach(function (el) { prepare(el); });
    scope.querySelectorAll(TARGETS_SCALE).forEach(function (el) { prepare(el, 'vp-reveal--scale'); });
    scope.querySelectorAll(TARGETS_SIDE).forEach(function (el) {
      // Richtung anhand der realen Position im Layout bestimmen
      // (imgtext--reverse etc. wird so automatisch richtig behandelt)
      var mid = window.innerWidth / 2;
      var rect = el.getBoundingClientRect();
      var fromLeft = rect.left + rect.width / 2 <= mid;
      // Mobil sind die Spalten gestapelt → seitliche Bewegung wäre unruhig
      prepare(el, isMobile ? null : (fromLeft ? 'vp-reveal--left' : 'vp-reveal--right'));
    });
  }

  initReveals();

  /* ─────────────────────────────────────────────────────────────
     2) Parallax — große Bilder bewegen sich beim Scrollen minimal
     langsamer als die Seite (nur Desktop, nur transform, rAF-
     gedrosselt). Stärke kommt aus dem Theme-Setting (0 = aus).
     Container behalten overflow:hidden; das Bild wird leicht
     überskaliert, damit keine Ränder aufreißen.
     ───────────────────────────────────────────────────────────── */
  var strength = Math.max(0, Math.min(30, Number(cfg.parallax) || 0)) / 100;
  var refreshParallax = null;   // wird gesetzt, wenn Parallax aktiv ist (für Editor-Reload)

  if (strength > 0 && !isMobile) {
    // Hero absichtlich NICHT dabei: dessen Ken-Burns-Intro ist eine
    // CSS-Animation und würde das Parallax-Transform überschreiben.
    var PARALLAX_TARGETS = [
      '.imgtext__media img',
      '.story-split__media img',
      '.konfig-teaser__media img'
    ].join(', ');

    var pItems = [];

    var collectParallax = function () {
      pItems = [];
      document.querySelectorAll(PARALLAX_TARGETS).forEach(function (img) {
        var host = img.closest('.imgtext__media, .story-split__media, .konfig-teaser__media');
        if (!host) return;
        host.classList.add('vp-parallax');
        pItems.push({ img: img, host: host, factor: strength });
      });
    };

    var ticking = false;
    var parallaxFrame = function () {
      ticking = false;
      var vh = window.innerHeight;
      pItems.forEach(function (it) {
        var rect = it.host.getBoundingClientRect();
        if (rect.bottom < -80 || rect.top > vh + 80) return;  // außerhalb → nichts tun
        // Fortschritt des Elements durch den Viewport: -1 … 1
        var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
        var shift = -progress * rect.height * it.factor;
        it.img.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0) scale(' + (1 + it.factor * 2).toFixed(3) + ')';
      });
    };
    var requestParallax = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(parallaxFrame); }
    };

    refreshParallax = function () { collectParallax(); requestParallax(); };

    collectParallax();
    parallaxFrame();
    window.addEventListener('scroll', requestParallax, { passive: true });
    window.addEventListener('resize', refreshParallax, { passive: true });
  }

  /* ─────────────────────────────────────────────────────────────
     3) Theme-Editor: Section neu gerendert → Effekte neu aufsetzen
     ───────────────────────────────────────────────────────────── */
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    if (refreshParallax) refreshParallax();
  });
})();

/* ═══════════════════════════════════════════════════════════════
   Scroll-Scenes — Sektionen verschmelzen über scroll-gekoppelte
   Ebenen, statt hart nacheinander zu stehen:
   · .bg-num-Ghostzahlen driften langsamer als der Inhalt (Tiefe)
   · Sektionsinhalte „schweben" minimal gegen die Scrollrichtung
   · Spezialsektionen bekommen einen Fortschrittswert (--vpp 0…1)
     für CSS-Effekte (z. B. Stammbaum-Linie der Generationen)
   · Geschichte-Timeline: Scrollytelling mit Sticky-Jahreszahl,
     selbstzeichnender Linie und aktivem Meilenstein
   Alles rAF-gedrosselt, nur transform/opacity, deaktiviert bei
   reduzierter Bewegung oder Theme-Setting „Animationen: aus".
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var cfg     = window.VAUPEL_MOTION || {};
  var enabled = cfg.enabled !== false;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!enabled || reduced) return;
  var isMobile = window.matchMedia('(max-width: 900px)').matches;

  var scenes = [];

  function collectScenes() {
    scenes = [];

    // Ghost-Hintergrundzahlen: eigene, langsamere Ebene
    document.querySelectorAll('.bg-num').forEach(function (el) {
      scenes.push({ el: el, type: 'drift' });
    });

    // Sektionsinhalte schweben dezent (nur Desktop; Sticky-Sektionen
    // wie die Timeline ausgenommen, damit position:sticky sauber bleibt)
    if (!isMobile) {
      document.querySelectorAll('.section > .container').forEach(function (el) {
        if (el.querySelector('[data-gtl]')) return;
        if (el.closest('.hero-full')) return;
        scenes.push({ el: el, type: 'float' });
      });
    }

    // Fortschrittsvariable für CSS (Generationen-Linie u. a.)
    document.querySelectorAll('.generations, [data-scroll-scene]').forEach(function (el) {
      scenes.push({ el: el, type: 'progress' });
    });
  }

  // ── Geschichte-Timeline (Scrollytelling) ───────────────────
  var gtl, gtlItems = [], gtlYear, gtlFill, gtlActive = -1;

  function collectTimeline() {
    gtl = document.querySelector('[data-gtl]');
    if (!gtl) return;
    gtlItems = Array.prototype.slice.call(gtl.querySelectorAll('[data-gtl-item]'));
    gtlYear  = gtl.querySelector('[data-gtl-year]');
    gtlFill  = gtl.querySelector('[data-gtl-line]');
    gtlActive = -1;
  }

  function timelineFrame(vh) {
    if (!gtl || !gtlItems.length) return;
    var rect = gtl.getBoundingClientRect();
    if (rect.bottom < -100 || rect.top > vh + 100) return;

    // Linie füllt sich bis zur Bildschirmmitte
    if (gtlFill) {
      var p = (vh * 0.5 - rect.top) / rect.height;
      p = Math.max(0, Math.min(1, p));
      var fillPx = p * 0;
      var lineEl = gtlFill.parentElement;
      var lr = lineEl.getBoundingClientRect();
      fillPx = p * lr.height;
      // Zukunfts-Abschnitt (gestrichelt): Füllung stoppt dort, Linie bekommt die Grenze als CSS-Var
      var future = gtl.querySelector('.gtl__item--future');
      if (future) {
        var futTopVp = future.getBoundingClientRect().top + 46;         // Punkt des ersten Zukunfts-Meilensteins (Viewport)
        var capPx = futTopVp - lr.top;
        capPx = Math.max(0, Math.min(lr.height, capPx));
        lineEl.style.setProperty('--gtl-future-top', capPx.toFixed(1) + 'px');
        // gestrichelte Füllung: läuft ab der Grenze mit dem Scrollfortschritt weiter
        var dashFill = gtl.querySelector('[data-gtl-line-dash]');
        if (dashFill) {
          var dpx = Math.max(0, Math.min(lr.height - capPx, fillPx - capPx));
          dashFill.style.height = dpx.toFixed(1) + 'px';
        }
        fillPx = Math.min(fillPx, capPx);   // solide Füllung endet an der Grenze
        // Ghost-Jahr wechselt die Seite erst, wenn die Strichel-Grenze
        // die Bildschirmmitte passiert hat — nicht schon beim Aktiv-Wechsel
        var goFut = futTopVp <= vh * 0.5;
        if (goFut) {
          var stage = gtl.querySelector('.gtl__stage');
          if (stage) gtl.style.setProperty('--gtl-shift', (gtl.offsetWidth - stage.offsetWidth) + 'px');
        }
        gtl.classList.toggle('is-future', goFut);
      }
      gtlFill.style.height = fillPx.toFixed(1) + 'px';
    }

    // aktiv = Meilenstein, dessen Mitte der Bildschirmmitte am nächsten ist
    var best = -1, bestDist = Infinity, mid = vh * 0.5;
    gtlItems.forEach(function (it, i) {
      var r = it.getBoundingClientRect();
      var d = Math.abs(r.top + r.height / 2 - mid);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    if (best !== gtlActive) {
      gtlActive = best;
      gtlItems.forEach(function (it, i) { it.classList.toggle('is-active', i === gtlActive); });
      if (gtlYear) {
        var y = gtlItems[gtlActive].getAttribute('data-year') || '';
        if (gtlYear.textContent !== y) {
          gtlYear.classList.remove('is-swap');
          void gtlYear.offsetWidth;              // Reflow → Animation neu starten
          gtlYear.textContent = y;
          gtlYear.classList.add('is-swap');
        }
      }
    }
  }

  // ── Gemeinsamer rAF-Loop ───────────────────────────────────
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    scenes.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      if (r.bottom < -140 || r.top > vh + 140) return;
      // Fortschritt der Element-Passage durch den Viewport: 0 → 1
      var p = (vh - r.top) / (vh + r.height);
      p = Math.max(0, Math.min(1, p));
      if (s.type === 'drift') {
        s.el.style.transform = 'translate3d(0,' + ((0.5 - p) * 90).toFixed(1) + 'px,0)';
      } else if (s.type === 'float') {
        s.el.style.transform = 'translate3d(0,' + ((0.5 - p) * 16).toFixed(1) + 'px,0)';
      } else {
        s.el.style.setProperty('--vpp', p.toFixed(4));
      }
    });
    timelineFrame(vh);
  }
  function requestFrame() {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }

  collectScenes();
  collectTimeline();
  frame();
  window.addEventListener('scroll', requestFrame, { passive: true });
  window.addEventListener('resize', function () { collectScenes(); collectTimeline(); requestFrame(); }, { passive: true });

  // Theme-Editor: Section neu gerendert → Szenen neu einsammeln
  document.addEventListener('shopify:section:load', function () {
    collectScenes();
    collectTimeline();
    requestFrame();
  });
})();
